import React from 'react';
import { Select} from 'antd';


class OriginalIDTypeSelector extends React.Component {

    render() {
        const idTypes = this.props.idTypes;
        return (
            <div>
                <Select
                    style={{ width: '100%' }}
                    placeholder={this.props.placeholder}
                    optionFilterProp="children"
                    onChange={this.props.onChange}
                    value ={this.props.value}
                    defaultValue={null}
                 >
                    {idTypes.map((idType, idx) => {
                        return <Select.Option value={idType.code} key={idType.code}>{idType.value}</Select.Option>
                    })}
                </Select>
            </div>
        )
    }

}

export default OriginalIDTypeSelector;
